import i18n from "@/i18n";

export const SUPPORTED_LANGS = ["es", "en", "it", "de", "fr"] as const;

const LANG_RE = /^\/(es|en|it|de|fr)(?=\/|$)/;

/** Quita el prefijo de idioma: "/es/retail" -> "/retail" */
export const stripLang = (pathname: string) => pathname.replace(LANG_RE, "") || "/";

/** Añade el prefijo del idioma activo: "/retail" -> "/es/retail" */
export const withLang = (path: string) => {
  if (!path.startsWith("/")) return path;
  const lang = (i18n.language || "es").substring(0, 2);
  const safe = (SUPPORTED_LANGS as readonly string[]).includes(lang) ? lang : "es";
  const clean = stripLang(path);
  return clean === "/" ? `/${safe}` : `/${safe}${clean}`;
};
